exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-group-order-form-page-1 .btn-social > :first-child {\n  height: inherit;\n}", ""]);

// exports
